export default __webpack_public_path__ + "static/media/img-loading.50354f44.svg";